<div>
    <!-- Quick add medications section -->
    <div *ngIf="!isReadOnly && !isConcomitantTreatment && topUsedMedications && topUsedMedications.length > 0"
        class="mb-3">
        <div class="d-flex flex-wrap gap-2 align-items-center">
            <p class="mb-0 fw-bold top-used-label">Top Used:</p>
            <span *ngFor="let med of topUsedMedications" (click)="quickAddMedication(med)"
                class="topUsedButton py-2 px-3 d-flex align-items-center"
                [class.active]="isMedicationSelected(med.id)">{{
                med.name }}</span>
        </div>
    </div>

    <div *ngIf="!isReadOnly && searchMedicationsFn">
        <p-multiSelect [(ngModel)]="selectedMedicines" (onPanelHide)="resetPanel()" styleClass="w-100" class="w-100"
            [options]="options$ | async" (onChange)="onMedicineSelect($event)" optionLabel="label" optionValue="value"
            [lazy]="true" [virtualScroll]="true" virtualScrollItemSize="30" [filter]="true"
            (onFilter)="onFilter($event)" placeholder="Search for Medications" [showToggleAll]="false"
            [selectedItemsLabel]="'Search for Medications'" maxSelectedLabels="0" [resetFilterOnHide]="true"
            (onPanelShow)="focusSearchBar"></p-multiSelect>
    </div>

    <div *ngIf="selectedMedicines.length > 0" class="mt-3"></div>

    <form class="px-0" [formGroup]="internalForm">
        <div *ngIf="selectedMedicines.length > 0" formArrayName="medicineForms">
            <!-- Simplified Mode: Show medicines without accordion -->
            <div *ngIf="simplifiedMode">
                <div *ngFor="let medicineForm of medicineForms.controls; let i = index; trackBy: trackById"
                    [formGroupName]="i" class="mb-3 p-3 border rounded mb-0"
                    style="background-color: #f7fafc !important;">
                    <div class="d-flex justify-content-between align-items-center">
                        <span class="fw-bold">{{ medicineForm.get("medicineMetadata").value.name }}</span>
                        <button *ngIf="!isReadOnly && !medicineForm.get('isRequired')?.value" type="button"
                            class="medicine-btn"
                            (click)="removeMedicine(medicineForm.get('medicineMetadata')?.value.id)">
                            <i class="pi pi-trash" style="font-size: 20px"></i> {{ removeButtonLabel }}
                        </button>
                    </div>
                    <!-- Hidden form structure for data submission -->
                    <div [formGroup]="medicineForm" style="display: none;">
                        <div formArrayName="titrations">
                            <div *ngFor="let titrationForm of medicineForm.get('titrations').controls; let j = index"
                                [formGroupName]="j">
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Normal Mode: Show full accordion with all features -->
            <p-accordion *ngIf="!simplifiedMode" [expandIcon]="'pi pi-chevron-down'" [collapseIcon]="'pi pi-chevron-up'"
                [activeIndex]="activeIndex" (onClose)="onAccordionClose($event)" (onOpen)="onAccordionOpen($event)">
                <p-accordionTab iconPos="end" *ngFor="
            let medicineForm of medicineForms.controls;
            let i = index;
            trackBy: trackById" [formGroupName]="i">
                    <ng-template pTemplate="header">
                        <div class="header-container">
                            {{ medicineForm.get("medicineMetadata").value.name }}
                            <button *ngIf="!isReadOnly && !medicineForm.get('isRequired')?.value" type="button"
                                class="medicine-btn"
                                (click)="removeMedicine(medicineForm.get('medicineMetadata')?.value.id)"> <i
                                    class="pi pi-trash" style="font-size: 20px"></i> {{ removeButtonLabel }}</button>
                        </div>
                    </ng-template>

                    <div [formGroup]="medicineForm">
                        <div class="chronic-medicine-container mb-2" *ngIf="!isConcomitantTreatment">
                            <p-inputSwitch formControlName="isChronicMedication"
                                [disabled]="isReadOnly"></p-inputSwitch>
                            <p>&nbsp; Chronic Disease Medication</p>
                        </div>

                        <div *ngIf="this.isConcomitantTreatment" class="date-container pb-3">
                            <div class="row gx-5">
                                <div class="col-md-6">
                                    <label for="startDate">Start Date:</label>
                                    <p-calendar id="startDate" styleClass="w-100 p-0 border-0"
                                        class="form-control handleBDInput border-0 w-100 bg-dark-subtle"
                                        formControlName="startDate" dateFormat="dd-mm-yy"
                                        [maxDate]="maxSelectableEndDate" (onSelect)="updateMinEndDate(i)"
                                        [disabled]="isReadOnly" appendTo="body"></p-calendar>
                                </div>

                                <div class="col-md-6">
                                    <label for="endDate">End Date:</label>
                                    <p-calendar id="endDate" styleClass="w-100 p-0 border-0"
                                        class="form-control handleBDInput border-0 w-100 bg-dark-subtle"
                                        formControlName="endDate" dateFormat="dd-mm-yy"
                                        [minDate]="minSelectableStartDate" [maxDate]="yesterday"
                                        (onSelect)="updateMaxStartDate(i)" [disabled]="isReadOnly"
                                        appendTo="body"></p-calendar>
                                </div>
                            </div>
                        </div>

                        <div formArrayName="titrations">
                            <div *ngFor="
                  let titrationForm of medicineForm.get('titrations').controls;
                  let j = index
                " [formGroupName]="j" class="titration-container row gy-2">
                                <div class="col-12 mb-3 d-flex justify-content-between align-items-center">
                                    <p class="h3 mb-0">{{ getOrdinalSuffix(j + 1) }} Titration</p>
                                    <button *ngIf="j > 0 && !isReadOnly" type="button" (click)="removeTitration(i, j)"
                                        class="medicine-btn">
                                        <i class="pi pi-trash" style="font-size: 20px"></i>Remove
                                        Titration
                                    </button>
                                </div>

                                <div class="col-sm-6 col-md-3 mb-1">
                                    <label for="dosage">Medicine Dosage</label>
                                    <div class="row dosage-selectButton">
                                        <p-selectButton id="dosage" [allowEmpty]="false" [options]="intervalOptions"
                                            formControlName="dosage" optionLabel="label" optionValue="value"
                                            [disabled]="isReadOnly">
                                        </p-selectButton>
                                    </div>
                                </div>

                                <div class="col-sm-6 col-md-3">
                                    <label for="directionDropdown">Medicine Direction</label>
                                    <div class="row" class="medication-component">
                                        <p-dropdown id="directionDropdown" formControlName="direction"
                                            [options]="directionOptions" optionLabel="label" optionValue="value"
                                            [disabled]="isReadOnly" appendTo="body">
                                        </p-dropdown>
                                    </div>
                                </div>

                                <div class="col-sm-6 col-md-3 mb-1">
                                    <label for="frequency">Medicine Frequency</label>
                                    <div class="row">
                                        <p-selectButton id="frequency" [allowEmpty]="false" [options]="intervalOptions"
                                            formControlName="frequency" optionLabel="label" optionValue="value"
                                            [disabled]="isReadOnly">
                                        </p-selectButton>
                                    </div>
                                </div>

                                <div class="col-sm-6 col-md-3 mb-1">
                                    <label class="invisible" for="frequencyDuration">Frequency Duration</label>
                                    <p-selectButton id="frequencyDuration" [allowEmpty]="false"
                                        [options]="intervalUnitOptions" formControlName="frequencyDuration"
                                        optionLabel="label" optionValue="value" [disabled]="isReadOnly">
                                    </p-selectButton>
                                </div>

                                <div class="col-md-9 mb-1">
                                    <label for="period">Medicine Duration</label>
                                    <p-selectButton id="period" [allowEmpty]="false" [options]="longIntervalOptions"
                                        formControlName="period" optionLabel="label" optionValue="value"
                                        [disabled]="isReadOnly">
                                    </p-selectButton>
                                </div>

                                <div class="col-md-3">
                                    <label class="invisible" for="periodDuration">Period Duration</label>
                                    <p-selectButton id="periodDuration" [allowEmpty]="false"
                                        [options]="intervalUnitOptions" formControlName="periodDuration"
                                        optionLabel="label" optionValue="value" [disabled]="isReadOnly">
                                    </p-selectButton>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div *ngIf="!isReadOnly && !isConcomitantTreatment" class="row px-2 ml-2 mt-2">
                        <button type="button" class="medicine-btn" (click)="addTitration(i)">
                            <i class="pi pi-plus" style="font-size: 20px"></i> Add Titration
                        </button>
                    </div>
                </p-accordionTab>
            </p-accordion>
        </div>
    </form>

    <!-- Read-only message -->
    <div *ngIf="isReadOnly" class="mt-2 text-muted">
        <small>
            {{ isConcomitantTreatment ? 'Concomitant treatment' : 'Medication' }} information is read-only.
        </small>
    </div>
</div>